package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/** DSL 内建对象 `timer` 暴露的定时调度方法集（仅作为类型标记）。 */
class TimerApi private constructor() {
    companion object {
        @JvmField val INSTANCE: TimerApi = TimerApi()

        @JvmField val NOOP: TimerApi = INSTANCE
    }
}
